import { AbstractControl } from '@angular/forms';

function NameValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const name = /^[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1}([\s]{1,1}[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1})*$/;
    if (!name.test(control.value)) {
        return { name: true };
    }
    return null;
}

function calculaDigito(curp) {
    let segRaiz = curp.substring(0, 17);
    let chrCaracter = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";
    let intFactor = new Array(17);
    let lngSuma = 0.0;
    let lngDigito = 0.0;
    for (let i = 0; i < 17; i++) {
        for (let j = 0; j < 37; j++) {
            if (segRaiz.substring(i, i + 1) == chrCaracter.substring(j, j + 1)) {
                intFactor[i] = j;
            }
        }
    }
    for (let k = 0; k < 17; k++) {
        lngSuma = lngSuma + ((intFactor[k]) * (18 - k));
    }
    lngDigito = (10 - (lngSuma % 10));
    if (lngDigito == 10) {
        lngDigito = 0;
    }
    return lngDigito;
}


function validaCURP(curp) {
    let reg: any;
    if (curp.length === 18) {
        let digito = calculaDigito(curp);
        reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9][0-9]/;
        if (curp.search(reg)) {
            return false;
        }
        if (!(digito === parseInt(curp.substring(17, 18)))) {
            return false;
        }
        return true;
    } else {
        switch (curp.length) {
            case 10:
                reg = /[A-Z]{4}\d{6}/;
                break;
            case 11:
                reg = /[A-Z]{4}\d{6}[HM]/;
                break;
            case 12:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]/;
                break;
            case 13:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}/;
                break;
            case 14:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]/;
                break;
            case 15:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{2}/;
                break;
            case 16:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}/;
                break;
            case 17:
                reg = /[A-Z]{4}\d{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]/;
                break;
        }
        if (curp.length !== 18) {
            return false;
        }

        if (curp.search(reg)) {
            return false;
        }
        return true;
    }
}

function validRFC(rfc) {
    const rfc_pm = '^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$';
    const rfc_pf = '^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$';

    if (rfc.match(rfc_pm) || rfc.match(rfc_pf)) {
        return true;
    } else {
        return false;
    }
}

function CurpValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let valor = control.value;
    valor = valor.toUpperCase();
    if (valor === '' || valor === null) {
        return null;
    }

    if (!validaCURP(valor)) {
        return { curp: true };
    }
    return null;
}

function RfcValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let valor = control.value;
    valor = valor.toUpperCase();
    if (valor === '' || valor === null) {
        return null;
    }
    if (!validRFC(valor)) {
        return { rfc: true };
    }
    return null;
}

function CPValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let valor = control.value;
    let cp = /(^([0-9]{5,5})|^)$/;
    if (!cp.test(valor)) {
        return { cp: true };
    }
    return null;
}

function MovilValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let valor = control.value;
    let ptr = /^([0-9]{10,10})$/;
    if (!ptr.test(valor)) {
        return { movil: true };
    }
    return null;
}

function RFCorCURPValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let valor = control.value;
    valor = valor.toUpperCase();
    if (valor === '' || valor === null) {
        console.log('ES NULL');
        return null;
    }

    if (validRFC(valor) || validaCURP(valor)) {
        console.log('SI PASO LAS VALIDACIONES');
        console.log(validRFC(valor));
        console.log(validaCURP(valor));
        return null;
    }
    console.log('VA A FALLLAR EN TEORIA');
    return { rfcOrCurp: true };
}


export {
    NameValidator,
    CurpValidator,
    RfcValidator,
    CPValidator,
    MovilValidator,
    RFCorCURPValidator
};
